import React, { useMemo } from "react";
import { ResponsiveContainer, BarChart, Bar, XAxis, YAxis } from "recharts";
import GaugeThumb from "./GaugeThumb";

const LEGACY_TRACK_LEFT = 17;
const LEGACY_TRACK_WIDTH = 247;

const resolveThumbPercent = ({ thumbPercent, thumbLeft }) => {
  if (thumbPercent != null) return Math.max(0, Math.min(1, thumbPercent));

  if (thumbLeft != null) {
    return Math.max(
      0,
      Math.min(1, (thumbLeft - LEGACY_TRACK_LEFT) / LEGACY_TRACK_WIDTH)
    );
  }

  return 0.53;
};

// Track segment dataset for Recharts rendering
const TRACK_DATA = [{ name: "volume_track", value: 100 }];

/**
 * Total Crypto Volume RSI-style gauge (Figma 1155:594) rendered using Recharts.
 */
const VolumeGauge = ({ thumbPercent, thumbLeft }) => {
  const thumbPosition = useMemo(
    () => resolveThumbPercent({ thumbPercent, thumbLeft }),
    [thumbPercent, thumbLeft]
  );

  return (
    <div className="absolute inset-x-4 bottom-3 flex flex-col">
      {/* Header Labels */}
      <div className="mb-2 flex justify-between text-xs leading-4 text-text-primary">
        <span>Oversold</span>
        <span>Overbought</span>
      </div>

      {/* Horizontal Gauge Bar Track & Indicator */}
      <div className="relative h-2 w-full overflow-visible">
        {/* Recharts Bar Track */}
        <div className="absolute inset-0 size-full overflow-hidden rounded-2xl">
          <ResponsiveContainer width="100%" height="100%">
            <BarChart
              layout="vertical"
              data={TRACK_DATA}
              margin={{ top: 0, right: 0, bottom: 0, left: 0 }}
            >
              <defs>
                <linearGradient
                  id="volumeTrackGradient"
                  x1="0%"
                  y1="0%"
                  x2="100%"
                  y2="0%"
                >
                  <stop offset="1.01%" stopColor="#EA3943" />
                  <stop offset="75.48%" stopColor="#FFA400" />
                  <stop offset="97.98%" stopColor="#4AB932" />
                </linearGradient>
              </defs>

              <XAxis type="number" domain={[0, 100]} hide />
              <YAxis type="category" dataKey="name" hide />

              <Bar
                dataKey="value"
                fill="url(#volumeTrackGradient)"
                radius={[16, 16, 16, 16]}
                isAnimationActive={false}
              />
            </BarChart>
          </ResponsiveContainer>
        </div>

        {/* Dynamic Thumb Position Indicator */}
        <GaugeThumb percent={thumbPosition} />
      </div>
    </div>
  );
};

export default VolumeGauge;